import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Container, Panel } from 'shell/components';

const Desktop = ({ options, selected, onBeforeChange, onChange }) => {
    const { t } = useTranslation();
    return (
        <CustomContainer device={'desktop'}>
            <CustomPanel
                label={t('account-settings.title', 'Account Settings')}
                options={options}
                selected={selected}
                onBeforeChange={onBeforeChange}
                onChange={onChange}
            />
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(() => {
    return {
        display: 'block',
        height: 'unset',
    };
});

const CustomPanel = styled(Panel)(() => {
    return {
        minHeight: '100%',
        height: 'auto',
    };
});

export default Desktop;
